import { Grid, Paper, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////

export const AssPlayerLostConnection: React.FC = () => {

    const { t } = useTranslation("assessment");
    const theme = useTheme();

    return (
        <Paper elevation={2} sx={{
            backgroundColor: theme.palette.error.main,
            borderRadius: "16px"
        }}>
            <Grid container
                direction="column"
                alignContent="center"
                alignItems="center"
                textAlign="center"
                spacing={4}
                marginTop={2}
                paddingTop={2}
                paddingBottom={12}
            >
                <Grid>
                    <Typography variant="h1" component="span" color="white">
                        <strong>{t("AssPlayer.Connection.LossConnectionText_L1")}</strong>
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant="h3" component="p" color="white">
                        <strong>{t("AssPlayer.Connection.LossConnectionText_L2")}</strong>
                    </Typography>
                    <Typography variant="h3" component="p" color="white">
                        <strong>{t("AssPlayer.Connection.LossConnectionText_L3")}</strong>
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant="h3" component="span" color="white">
                        <strong>{t("AssPlayer.Connection.LossConnectionText_L4")}</strong>
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
};
